import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'comerciales',
  getAllParams: ({
    page,
    perPage,
    searchName,
    searchCode,
  }) => ({
    'filter[nombre]': searchName,
    'filter[clave]': searchCode,
    page,
    per_page: perPage,
  }),
});
